<mat-card>
  <h1 mat-dialog-title>{{ "Create_folder.Create_folder" | translate }}</h1>
  <div mat-dialog-content>
    <form [formGroup]="expForm" (ngSubmit)="onSubmit()" class="example-form">
      <mat-form-field>
        <mat-label
          >{{ "Create_folder.Name" | translate }}
          <span class="text-red">*</span></mat-label
        >
        <input
          matInput
          id="folderName"
          type="text"
          formControlName="folderName"
          value="folderName"
        />
        <mat-error>{{
          getErrorMessage("folderName", "Create_folder.Name")
        }}</mat-error>
      </mat-form-field>
      <br />
      <mat-form-field class="example-full-width">
        <mat-label
          >{{ "Create_folder.Description" | translate }}
          <span class="text-red">*</span></mat-label
        >
        <textarea
          matInput
          id="folderDesc"
          formControlName="folderDesc"
          value="folderDesc"
        ></textarea>
        <mat-error>{{
          getErrorMessage("folderDesc", "Create_folder.Description")
        }}</mat-error>
      </mat-form-field>
      <br />
    </form>
    <button
      mat-button
      mat-raised-button
      cdkFocusInitial
      color="primary"
      type="submit"
      (click)="onSubmit()"
      [disabled]="buttonDisable"
    >
      {{ "Create_folder.Save" | translate }}
    </button>
    <button
      mat-button
      mat-raised-button
      color="primary"
      (click)="edit()"
      [disabled]="buttonDisable"
    >
      {{ "Create_folder.Modify" | translate }}
    </button>
    <button
      mat-button
      mat-raised-button
      color="primary"
      (click)="delete()"
      [disabled]="buttonDisable"
    >
      {{ "Create_folder.Delete" | translate }}
    </button>
    <button
      mat-button
      mat-raised-button
      cdkFocusInitial
      color="primary"
      (click)="reset()"
    >
      {{ "Create_folder.Reset" | translate }}
    </button>
    <dg-listbox
      *ngIf="showListbox"
      [content]="content"
      [columnConfig]="columnConfig"
      [multiple]="false"
      (output)="getData($event)"
      class="example-full-width"
    >
    </dg-listbox>
  </div>
  <mat-dialog-actions align="end" *ngIf="dialogRef">
    <button mat-button mat-dialog-close>
      {{ "Create_folder.Close" | translate }}
    </button>
  </mat-dialog-actions>
</mat-card>
